import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShipperFeatureShipmentRoutingModule } from './shipper-feature-shipment-routing.module';
import { SharedShipperDataAccessShipperModule } from '@fleetoperate/shared/shipper/data-access-shipper';
import { ShipmentListModule } from './shipment-list/shipment-list.module';
import { CreateLoadModule } from './create-load/create-load.module';
import { ShipmentDetailsModule } from './shipment-details/shipment-details.module';
import { ShipmentQuotesModule } from './shipment-quotes/shipment-quotes.module';
import { SharedDataAccessErrorModule } from '@fleetoperate/shared/data-access-error';
import { CancelLoadModalModule } from './shared/cancel-load-modal/cancel-load-modal.module';
@NgModule({
  imports: [
    CommonModule,
    ShipmentListModule,
    CreateLoadModule,
    ShipmentDetailsModule,
    ShipmentQuotesModule,
    CancelLoadModalModule,
    SharedShipperDataAccessShipperModule,
    ShipperFeatureShipmentRoutingModule,  
    SharedDataAccessErrorModule,
    ShipperFeatureShipmentRoutingModule,
  ]
})
export class ShipperFeatureShipmentModule {}
